import React from "react";
import { Button } from "react-bootstrap";

export default function GreetingCard() {
  return (
    <div className="greeting-card">
      
      <p className="greeting-text">Good Morning, Adrian</p>

      <h3 className="time-text">08:35 AM, 11 Mar 2025</h3>

      {/* Profile */}
      <div className="profile-ring">
        <div className="profile-inner">
          <img
            src="/assets/img/profiles/avatar-27-1.jpg"
            alt="user"
          />
        </div>
      </div>

      {/* Badge */}
      <div className="production-badge">
        Production : 3.45 hrs
      </div>

      <p className="punch-text">
        <span>📡</span> Punch In at 10.00 AM
      </p>

      <Button className="punch-btn">Punch Out</Button>

      {/* CSS */}
      <style>
        {`
        .greeting-card {
          background: #fff;
          padding: 20px;
          border-radius: 5px;
          border: 1px solid #e5e7eb;
          text-align: center;
          width: 100%;
          max-width: 350px;
          margin: auto;
        }

        .greeting-text {
          margin: 0;
          font-size: 15px;
          color: #6b7280;
          font-weight: 500;
        }

        .time-text {
          margin: 8px 0 16px;
          font-weight: 700;
          font-size: 20px;
          color: #111827;
        }

        /* Profile Ring */
              .profile-ring {
          width: 128px; /* reduced from 140 */
          height: 128px;
          border-radius: 50%;
          background: conic-gradient(#22c55e 85%, #e5e7eb 0%);
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 15px;
        }

        .profile-inner {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          overflow: hidden;
          background: #ddd;
        }

        .profile-inner img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .production-badge {
          display: inline-block;
          background: #ff6b00;
          color: #fff;
          padding: 6px 14px;
          border-radius: 8px;
          font-size: 15px;
          font-weight: 500;
          margin-bottom: 12px;
        }

        .punch-text {
          font-size: 15px;
          color: #374151;
          margin-bottom: 15px;
        }

        .punch-text span {
          color: #ff6b00;
          margin-right: 6px;
        }

        .punch-btn {
          width: 100%;
          background: linear-gradient(180deg, #0f172a, #020617);
          border: none;
          border-radius: 8px;
          padding: 10px;
          font-size: 15px;
        }

        /* 🔥 Mobile Optimization */
        @media (max-width: 768px) {
          .greeting-card {
            padding: 16px;
          }

          .profile-ring {
            width: 100px;
            height: 100px;
          }

          .profile-inner {
            width: 80px;
            height: 80px;
          }

          .time-text {
            font-size: 18px;
          }
        }

        @media (max-width: 480px) {
          .profile-ring {
            width: 90px;
            height: 90px;
          }

          .profile-inner {
            width: 70px;
            height: 70px;
          }

          .time-text {
            font-size: 16px;
          }

          .greeting-text {
            font-size: 14px;
          }
        }
        `}
      </style>
    </div>
  );
}